import Emoji from '@admin/components/emojis/emoji'
import PropTypes from 'prop-types'
import React from 'react'

const map = {
  thumbsup: '1f44d',
  thumbsdown: '1f44e',
  smile: '1f604',
  cry: '1f625',
  rage: '1f621',
  heart: '2764-fe0f'
}

class Reaction extends React.Component {

  static contextTypes = {
    admin: PropTypes.object,
    network: PropTypes.object,
    reactions: PropTypes.object
  }

  static propTypes = {
    id: PropTypes.number,
    reactions: PropTypes.array,
    type: PropTypes.string,
    table: PropTypes.string,
    user_reactions: PropTypes.array,
    onReact: PropTypes.func,
    onUnreact: PropTypes.func
  }

  state = {
    show: false
  }

  _handleHideReactions = this._handleHideReactions.bind(this)
  _handleShowReactions = this._handleShowReactions.bind(this)
  _handleReaction = this._handleReaction.bind(this)

  render() {
    const { reactions, type } = this.props
    const { user } = this.context.admin
    const { show } = this.state
    if(reactions.length === 0) return null
    return (
      <div { ...this._getReaction() }>
        { show &&
          <div className="maha-reactions-reaction-users">
            { reactions.map((reaction) => (
              <div className="maha-reactions-reaction-user" key={ `user_${reaction.id}` }>
                { user.id === reaction.user.id ? 'You' : reaction.user.full_name }
              </div>
            ))}
          </div>
        }
        <Emoji unicode={ map[type] } />
        { reactions.length }
      </div>
    )
  }

  _getReaction() {
    return {
      className: 'maha-reactions-reaction',
      onMouseEnter: this._handleShowReactions,
      onMouseLeave: this._handleHideReactions,
      onClick: this._handleReaction
    }
  }

  _handleHideReactions() {
    this.setState({ show: false })
  }

  _handleShowReactions() {
    this.setState({ show: true })
  }

  _handleReaction() {
    const { id, table, type, user_reactions, onReact, onUnreact } = this.props
    const { user } = this.context.admin
    const action = _.includes(user_reactions, type) ? onUnreact : onReact
    action(table, id, {
      id: user.id,
      full_name: user.full_name,
      initials: user.initials,
      photo: user.photo,
      type
    })
    this.context.network.request({
      method: 'PATCH',
      endpoint: `/api/admin/${table}/${id}/react/${type}`,
      onFailure: (result) => {},
      onSuccess: (result) => {}
    })
  }

}

export default Reaction
